import { g as n } from "../../chunks/get-is-open-24-hours.BowCHFXK.js";
const o = (e) => {
  const s = e == null ? void 0 : e.marketedFacilityHours;
  return !!(s && s.length > 0 && s.some((r) => r.open || r.close));
};
export {
  n as getIsOpen24Hours,
  o as locationHasHours
};
